import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';

import { setFiltersPushUser } from '../../utils';
import '../../../Table/Table.css'
import { useNavigate } from '../../../../../hooks';

const StyledCellLinkWithFilter = ({
    path,
    text,
    destinationTableUrl,
    primaryLink,
    field,
    value,
    currentPage,
}) => {

    const navigate = useNavigate({
        pageName: currentPage
    })

    return (
        <Link
            title={text}
            onClick={() => setFiltersPushUser({
                destinationTableUrl: destinationTableUrl,
                destinationPath: path,
                items: [{ field, value }],
                navigate,
            })}
            className={primaryLink ? 'link' : 'underlink'}
        >
            {text}
        </Link>
    )
}

StyledCellLinkWithFilter.propTypes = {
    path: PropTypes.string.isRequired,
    text: PropTypes.string.isRequired,
    from: PropTypes.string.isRequired,
    destinationTableUrl: PropTypes.string.isRequired,
    field: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
    currentPage: PropTypes.string.isRequired,
    primaryLink: PropTypes.bool,

};

StyledCellLinkWithFilter.defaultProps = {
    primaryLink: false
};

export default StyledCellLinkWithFilter;
